import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useNavigate } from 'react-router';

import { AddDataClassification } from './data-classifications/sheet-add';
import { DataClassificationTable } from './data-classifications/table';
import { AddDocumentClass } from './document-classes/sheet-add';
import { DocumentClassTable } from './document-classes/table';
import { AddDocumentType } from './document-types/sheet-add';
import { DocumentTypeTable } from './document-types/table';
import { AddEntityType } from './entity-types/sheet-add';
import { EntityTypeTable } from './entity-types/table';
import { AddMetadataType } from './metadata-types/sheet-add';
import { MetaDataTypeTable } from './metadata-types/table';
import { AddSourceSystem } from './source-systems/sheet-add';
import { SourceSystemTable } from './source-systems/table';

export function Doc() {
	const nav = useNavigate();
	const tab = window.location.pathname.split('/').pop();
	return (
		<Tabs defaultValue={tab} onValueChange={(value) => nav(`/doc/${value}`)}>
			<TabsList className="grid w-full grid-cols-6">
				<TabsTrigger value="data-classifications">Data Classifications</TabsTrigger>
				<TabsTrigger value="document-classes">Document Classes</TabsTrigger>
				<TabsTrigger value="document-types">Document Types</TabsTrigger>
				<TabsTrigger value="entity-types">Entity Types</TabsTrigger>
				<TabsTrigger value="metadata-types">Metadata Types</TabsTrigger>
				<TabsTrigger value="source-systems">Source Systems</TabsTrigger>
			</TabsList>
			<TabsContent value="data-classifications">
				<Card>
					<CardHeader>
						<span className="flex flex-row justify-between">
							<CardTitle>Data Classifications</CardTitle>
							<AddDataClassification />
						</span>
					</CardHeader>
					<CardContent className="space-y-2">
						<DataClassificationTable />
					</CardContent>
				</Card>
			</TabsContent>
			<TabsContent value="document-classes">
				<Card>
					<CardHeader>
						<span className="flex flex-row justify-between">
							<CardTitle>Document Classes</CardTitle>
							<AddDocumentClass />
						</span>
					</CardHeader>
					<CardContent className="space-y-2">
						<DocumentClassTable />
					</CardContent>
				</Card>
			</TabsContent>
			<TabsContent value="document-types">
				<Card>
					<CardHeader>
						<span className="flex flex-row justify-between">
							<CardTitle className="mt-2">Document Types</CardTitle>
							<AddDocumentType />
						</span>
					</CardHeader>
					<CardContent className="space-y-2">
						<DocumentTypeTable />
					</CardContent>
				</Card>
			</TabsContent>
			<TabsContent value="entity-types">
				<Card>
					<CardHeader>
						<span className="flex flex-row justify-between">
							<CardTitle>Entity Types</CardTitle>
							<AddEntityType />
						</span>
					</CardHeader>
					<CardContent className="space-y-2">
						<EntityTypeTable />
					</CardContent>
				</Card>
			</TabsContent>
			<TabsContent value="metadata-types">
				<Card>
					<CardHeader>
						<span className="flex flex-row justify-between">
							<CardTitle className="mt-2">Metadata Types</CardTitle>
							<AddMetadataType />
						</span>
					</CardHeader>
					<CardContent className="space-y-2">
						<MetaDataTypeTable />
					</CardContent>
				</Card>
			</TabsContent>
			<TabsContent value="source-systems">
				<Card>
					<CardHeader>
						<span className="flex flex-row justify-between">
							<CardTitle className="mt-2">Source Systems</CardTitle>
							<AddSourceSystem />
						</span>
					</CardHeader>
					<CardContent className="space-y-2">
						<SourceSystemTable />
					</CardContent>
				</Card>
			</TabsContent>
		</Tabs>
	);
}
